import React from 'react';
import { Link } from 'react-router-dom';
import './HeroSection.css';

const HeroSection = () => {
    return (
        <div className="hero-container">


            <div className="hero-content">
                <h1>
                    TRANSFORMĂ-ȚI <br />
                    <span className="text-green">CORPUL ȘI MINTEA</span>
                </h1>
                <p>
                    Planuri de nutriție personalizate și antrenamente create de experți
                    pentru a te ajuta să îți atingi obiectivele rapid și eficient.
                </p>

                <div className="hero-btns">

                    <Link to="/plans">
                        <button className="btn btn-primary">VEZI PLANURILE</button>
                    </Link>


                    <Link to="/about">
                        <button className="btn btn-outline">CINE SUNT?</button>
                    </Link>
                </div>
            </div>

        </div>
    );
};

export default HeroSection;